import React from 'react';
import { Outlet } from 'react-router-dom';
import './App.css';
import WeatherWidget from './WeatherWidget';
import WelcomeModal from './WelcomeModal';

function Layout() {
  return (
    <div className="App">
      <WelcomeModal />
      <header className="App-header">
        <div className="weather-widget-container">
          <WeatherWidget />
        </div>
      </header>
      <nav className="App-nav">
        <img 
            src={`${process.env.PUBLIC_URL}/logo2.jpg`} 
            alt="Bienvenida" 
            style={{ 
             position: 'absolute', 
             left: 15, 
             top: 70, 
             width: '2.5%', 
             margin: 0 
            }} 
        />

        <a href="/">Inicio</a>
        <a href="/Servicios">Servicios</a>
        <a href="/Eventos">Eventos</a>
        <a href="/Contacto">Contacto</a>
        <a href="/Transparencia">Transparencia</a>
      </nav>
      <main className="App-main">
        <Outlet /> {/* Renderiza dinámicamente el contenido según la ruta */}
      </main>
      <footer className="App-footer">
        {/* <p> Aviso de Privacidad / Gobierno Municipal de Atizapán, Estado de México </p> */}
        <p>Aviso de Privacidad / &copy; 2025-2027 Municipio de Atizapán. Todos los derechos reservados.</p>
      </footer>
    </div>
  );
}

export default Layout;
